export namespace Preference {
    export const KEY = "preference";

    export enum Lab {
        DevMode = "Development Mode",
        PageFeedback = "PageFeedback",
        QuickChatAgent = "Quick Chat Agent",
        PageTranslation = "Page Translation",
        AgenticUI = "PathFinder Agentic UI",
    }
    export class Value {
        userId: string;
        instanceId: string;
        labs: Set<Lab>;
    }
}
